import { MDBBadge, MDBBtn } from "mdbreact";
import demoOf from "../../../../../services/utilities/demo";

const lastDay = (day) =>
  new Date(day).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

const Header = ({
  company = {},
  isOpen,
  textColor,
  index,
  total,
  setActiveId,
}) => {
  const { name = "", subName = "", branches = [] } = company;

  // branches not yet promoted, and the demo that ends first
  const demos = branches.filter(
    ({ settings }) => (settings?.subscription || "demo") === "demo",
  );
  const [ending] = demos
    .map(({ settings }) => demoOf(settings))
    .filter(({ end }) => end)
    .sort((a, b) => a.end.localeCompare(b.end));

  return (
    <div className={`d-flex justify-content-between ${textColor} `}>
      <span>
        {total - index}. {name} {subName}
      </span>
      <div className="d-flex align-items-center">
        {demos.length > 0 && (
          <MDBBadge
            color={
              !ending
                ? "light"
                : ending.isOver || ending.daysLeft <= 7
                  ? "danger"
                  : "info"
            }
            className="mr-3"
            title={
              ending
                ? "Demo: closed from the day after its last day until promoted"
                : "Demo without an end date: never closed"
            }
          >
            Demo
            {demos.length > 1 && ` ×${demos.length}`}
            {ending
              ? ` · last day ${lastDay(ending.end)} · ${
                  ending.isOver
                    ? "closed"
                    : ending.daysLeft
                      ? `${ending.daysLeft} day(s) left`
                      : "ends today"
                }`
              : " · no end date"}
          </MDBBadge>
        )}
        <MDBBtn
          size="sm"
          color="white"
          rounded
          onClick={() => setActiveId((prev) => (index === prev ? -1 : index))}
          className="m-0 p-0 transition-all "
          style={{ width: isOpen ? "1.5rem" : "2rem" }}
        >
          <i
            style={{ rotate: `${isOpen ? 0 : 90}deg` }}
            className="fa fa-angle-down transition-all "
          />
        </MDBBtn>
      </div>
    </div>
  );
};

export default Header;
